import { Button, Center, Stack, Text, Title } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { IconFigmaAlertTriangle, IconFigmaArrowRight } from '@/assets/icons';
import { AuthCard } from '@/features/auth/components/AuthCard';
import { brandTextStyle } from '@/features/auth/components/authFieldStyles';

export const EmailAlreadyRegisteredCard = () => {
  const { t } = useTranslation();

  return (
    <AuthCard px={32} py={36} w={{ base: '100%', md: 440 }}>
      <Stack align="center" gap={16}>
        <Center
          w={56}
          h={56}
          style={{
            borderRadius: 12,
            backgroundColor: 'var(--color-status-danger-soft)',
            color: 'var(--color-status-danger)'
          }}
        >
          <IconFigmaAlertTriangle size={24} />
        </Center>
        <Title order={2} fz={24} fw={700} ta="center" style={brandTextStyle}>
          {t('registration.emailExistsTitle')}
        </Title>
        <Text size="sm" ta="center" style={{ color: 'var(--color-text-secondary)' }}>
          {t('registration.emailExistsMessage')}
        </Text>

        <Button
          component={Link}
          to="/login"
          fullWidth
          rightSection={<IconFigmaArrowRight size={15} />}
        >
          {t('auth.login')}
        </Button>
        <Button component={Link} to="/forgot-password" fullWidth variant="subtle">
          {t('auth.forgotPassword')}
        </Button>
      </Stack>
    </AuthCard>
  );
};
